import { AppConfig } from './../../app/app.config';
import { Component } from '@angular/core';
import { ViewController } from 'ionic-angular';
import { FormBuilder, Validators } from '@angular/forms';
import { NewsService } from './../../services/news.service';
import { LoaddingService } from './../../providers/loadding.service';
import { AlertService } from './../../providers/alert.service';

@Component({
  selector: 'page-send-message',
  templateUrl: 'send-message.html',
  providers: [
    NewsService,
    AlertService
  ]
})
export class SendMessagePage {

  constructor(

    private viewCtrl: ViewController,
    private newsService: NewsService,
    private alert: AlertService,
    private loadding: LoaddingService,
    private formBuilder: FormBuilder
  ) { }

  sendForm = this.formBuilder.group({
    'Receiver': [''],
    'Type': ['', [Validators.required]],
    'Title': ['', [Validators.required]],
    'Content': ['', [Validators.required]],
    Level: "02",
    selectUsers: [],
    UserName: AppConfig.User.UserName
  });

  // sendInput = new sendmessage;
  subUserNames = [];//当前用户的所有下级
  // subUserName:string='';
  Type = "01";
  types = [
    { id: "01", value: "上级代理" },
    { id: "02", value: "下级会员" },
    { id: "04", value: "所有直属下级" }
  ];

  ionViewDidLoad() {
    this.getSubUserNames();
    if(AppConfig.User.UserType=='0'){
      this.types=[
        { id: "01", value: "上级代理" }
      ];
    }
  }

  //开户类型更改事件
  //TQQ 2017-06-15
  changeReceiver($event) {
    this.Type = $event;
  }
  //消息发送事件
  //chen 2017-01-10
  //TQQ update 2017-06-15
  send() {
    if (this.sendForm.value['selectUsers']) {
      this.sendForm.value['Receiver'] = this.sendForm.value['selectUsers'].join(',');
    }
    if (this.sendForm.value['Type'] == "02" && !this.sendForm.value['Receiver']) {
      this.alert.showAlert("收件人不可为空");
      return;
    }
    this.newsService.sendNews(this.sendForm.value).then(s => {
      if (s.Result == true) {
        this.alert.showAlert("消息发送成功！");
        this.sendForm.setValue({ Receiver: '', Type: '', Title: '', Content: '', Level: "02", selectUsers: [], UserName: AppConfig.User.UserName });
        // this.sendForm.reset();
      } else {
        if (s.Error != "") {
          this.alert.showAlert(s.Error);
        } else {
          this.alert.showAlert("发送消息失败");
        }
      }
    });
  }

  //获取当前用户的下级列表
  //TQQ 2017-06-15
  getSubUserNames() {
    this.newsService.getSubUserNames().then(data => {
      if (!data || data.length < 1) {
        return;
      }
      data.forEach(u => {
        this.subUserNames.push({ label: u, value: u });
      });
      // this.subUserName=this.subUserName?this.subUserName:this.subUserNames[0].value;
    });
  }

  //页面关闭
  //chen 2017-01-11
  dismiss() {
    this.viewCtrl.dismiss();
  }

}

export class sendmessage {
  Content: string;
  Level: string = "02";
  Receiver: string = "";
  Title: string;
  Type: string;
  UserName: string;

}



// WEBPACK FOOTER //
// ./src/pages/send-message/send-message.ts